// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"98d659a9","848":"099d1b9b"}[chunkId] + ".chunk.css";
};